import { PopUpInformative } from 'components/molecules/Popup-informative/Popup-informative';
import './Popup-error-recover-password.scss';

export interface IPopupErrorRecoverPassword {
  closePopUp: () => void;
  email: string;
}

export const PopupErrorRecoverPassword = (
  props: IPopupErrorRecoverPassword
) => {
  return (
    <PopUpInformative
      text="Notamos algo inusual al intentar restablecer tu contraseña. Puedes intentarlo más tarde o escribirnos para ayudarte."
      title="Error"
      type="error"
      closePopUp={props.closePopUp}
      labelButton="solicitar soporte"
      onClickButton={() => {
        window.open('https://wa.me/17879995050', '_blank');
      }}
    ></PopUpInformative>
  );
};
